import { gql, TypedDocumentNode } from '@common/hooks';
import {
  PerformExtensionOfferActionMutationMutationCgResponse,
  PerformExtensionOfferActionMutationMutationVariables,
} from '@common/graphql';

export const PERFORM_EXTENSION_OFFER_ACTION_MUTATION: TypedDocumentNode<
  PerformExtensionOfferActionMutationMutationCgResponse,
  PerformExtensionOfferActionMutationMutationVariables
> = gql`
  mutation PerformExtensionOfferActionMutation(
    $extensionOfferId: ID!
    $input: PerformExtensionOfferActionInput!
  ) {
    performExtensionOfferAction(
      extensionOfferId: $extensionOfferId
      input: $input
    ) {
      error
      extensionOffer {
        id
        state

        canRetract {
          value
        }

        notVoidedSourceAssignmentTerms {
          id
          currentlyActive
          upcoming
          effectiveAt
          startDate
          endDate
          lengthInWeeks
          billingRegularRate
          shiftsPerWeek
          hoursPerShift
          shiftType
          timeoffDescription
          createdByName
          updatedFields
          updatedAt
          createdAt
        }

        staffingRequestAssignment {
          id
          extensionCount
          startDate
          billingRegularRate
          state
          extensionOffers {
            id
            state
          }

          activeExtensionOffer {
            id
            endDate
            originalEndDate
            timeoffDescription
            shiftType
            originalShiftType
            billingRegularRate
            originalBillingRegularRate
            createdAt
            state
            stateChangedAt
            extensionReason
            shiftsPerWeek
            hoursPerShift
            originalShiftsPerWeek
            originalHoursPerShift

            sourceEffectiveAt
            sourceStartDate
            sourcePercentageComplete
            sourceEndDate
            sourceEstimatedBudget

            notVoidedSourceAssignmentTerms {
              id
              currentlyActive
              upcoming
              effectiveAt
              startDate
              endDate
              lengthInWeeks
              billingRegularRate
              shiftsPerWeek
              hoursPerShift
              shiftType
              timeoffDescription
              createdByName
              updatedFields
              updatedAt
              createdAt
            }

            canRetract {
              value
            }
            canAccept {
              value
            }
            canReject {
              value
            }
            canApprove {
              value
            }
          }
        }
      }
    }
  }
`;
